import { createSharedState } from 'preact-shared-state-hook'
import type { Doodle } from '../../server/src/models'
import { comparing } from './utils'

export const doodleOrders = [
  ['filename:asc', '↑ ファイル名'],
  ['filename:desc', '↓ ファイル名'],
  ['createdAt:asc', '↑ 作成日時'],
  ['createdAt:desc', '↓ 作成日時'],
  ['updatedAt:asc', '↑ 更新日時'],
  ['updatedAt:desc', '↓ 更新日時'],
] as const

export type DoodleOrder = typeof doodleOrders[number][0]

const STORAGE_KEY_DOODLE_ORDER = 'zumeco:folders:doodleOrder'
const initialDoodleOrder = localStorage.getItem(STORAGE_KEY_DOODLE_ORDER)
const [useDoodleOrder, _setDoodleOrder] = createSharedState<DoodleOrder>(
  initialDoodleOrder && doodleOrders.some(([order]) => order === initialDoodleOrder)
    ? (initialDoodleOrder as DoodleOrder)
    : 'updatedAt:desc',
)
export const setDoodleOrder = (order: DoodleOrder) => {
  localStorage.setItem(STORAGE_KEY_DOODLE_ORDER, order)
  _setDoodleOrder(order)
}

export { useDoodleOrder }

export const sortDoodles = (doodles: Doodle[], doodleOrder: DoodleOrder) => {
  const [, doodleSortKey, doodleSortOrder] = doodleOrder.match(/(.+):(asc|desc)/)!
  return doodles.sort(comparing((x: Record<string, unknown>) => x[doodleSortKey]).reversed(doodleSortOrder === 'desc'))
}
